module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Volume-up-3a03b00c6286a7d6c91a2adde558ab50.svg";